import enviro from 'enviro';
import { Link } from 'foundations-components/transitional/components/Link';
import { PORTAL_53_HUBLET_PROPERTY_NAME, PORTAL_53_PORTALS_OBJECT_TYPE_ID, PORTAL_53_QA_PORTALS_OBJECT_TYPE_ID } from '../../constants/Portal53';
import { getFullUrl } from 'hubspot-url-utils';
import { stopPropagationHandler } from 'foundations-components/transitional/utils/DomEvents';
import { jsx as _jsx } from "react/jsx-runtime";
const getLink = (hublet, portalId) => {
  return `${getFullUrl('app', {
    envOverride: enviro.isQa() ? 'qa' : undefined,
    hubletOverride: hublet
  })}/reports-dashboard/${encodeURIComponent(portalId)}`;
};
const getPortalsObjectTypeId = () => {
  return enviro.isQa() ? PORTAL_53_QA_PORTALS_OBJECT_TYPE_ID : PORTAL_53_PORTALS_OBJECT_TYPE_ID;
};
/**
 * This property is used on portal 53 to display the portal id of a HubSpot customer. We want to
 * apply special linking behavior for these to assist in daily rep operations where entering the
 * reporting dashboard for these portals is a very common task.
 *
 * See lighthouse for more details: https://tools.hubteam.com/lighthouse/objects/p53_Portals/properties/portal_id/details?hublet=na1&portalId=53
 */
function FormattedPropertyPortalId({
  getAdditionalPropertyValue,
  objectId,
  placeholder,
  propertyValue,
  dataAttributes
}) {
  const hublet = getAdditionalPropertyValue(PORTAL_53_HUBLET_PROPERTY_NAME, objectId, getPortalsObjectTypeId());
  if (!propertyValue) {
    return /*#__PURE__*/_jsx("span", Object.assign({}, dataAttributes, {
      children: placeholder
    }));
  }

  // We need the hublet to determine proper linking URL. So if we don't have it, we can't link.
  if (!hublet) {
    return /*#__PURE__*/_jsx("span", Object.assign({}, dataAttributes, {
      children: propertyValue
    }));
  }
  return /*#__PURE__*/_jsx(Link, Object.assign({
    href: getLink(hublet, propertyValue),
    external: true,
    onClick: stopPropagationHandler
  }, dataAttributes, {
    children: propertyValue
  }));
}
export default FormattedPropertyPortalId;